import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import THEME from '../../../../../constants/theme';

export const buttonStyles = {
  color        : THEME.error,
  fontFamily   : 'Montserrat',
  fontSize     : 14,
  fontWeight   : '500',
  lineHeight   : 1.14,
  letterSpacing: 1.5,
};

export const ButtonDetails = styled(Button)`
  border-radius: 8px !important;
  color: ${THEME.primary} !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin: 21px 20px 10px 0;
  gap: 8px;
`;

export const Margin = styled.div`
  flex: 1;
`;
